// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-indicator
{
    padding: 20px 0;
    color: var(--ce-grey-70);
    text-align: center;
    font-size: 14px;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/presentational/LoadingIndicator/LoadingIndicator.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf","sourcesContent":[".loading-indicator\n{\n    padding: 20px 0;\n    color: var(--ce-grey-70);\n    text-align: center;\n    font-size: 14px;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
